import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../core/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { CATEGORIAS } from '../../interfaces/categorias'
import { PublicacionService } from '../../core/publicacion.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../interfaces/user';
import * as firebase from 'firebase';

import { FotosService } from '../../core/fotos.service';
import { ArchivoService } from '../../core/archivo.service';

//UPLOAD MULTI
import * as _ from 'lodash';
import { Archivo } from '../../interfaces/archivo';

@Component({
  selector: 'app-publicar',
  templateUrl: './publicar.component.html',
  styleUrls: ['./publicar.component.css']
})

export class PublicarComponent implements OnInit {


  // UPLOAD MULTI
  listaArchivos: Archivo;
  loading;

  // FOTOS
  // fotos$: any;

  fotos$: Observable<any[]>;

  // @Input() name;
  publicacionId;

  categorias = CATEGORIAS;

  formulario: FormGroup;

  cats = [
    { value: 'cat-0', nombre: 'Categoría 1' },
    { value: 'cat-1', nombre: 'Categoría 2' },
    { value: 'cat-2', nombre: 'Categoría 3' }
  ];

  cargando = false;
  iconoCat;

  mensaje: string;
  icono: string;
  clase: string;

  formErrores = {
    // 'categoria': '',
    // 'titulo': '',
    'texto': '',
    // 'precio': '',
  }

  mensajeError = false;

  mensajesValidacion = {
    // 'categoria': {
    //   'required': 'La categoría es obligatoria,',
    // },
    // 'titulo': {
    //   'required': 'El titulo es obligatorio.',
    //   'minlength': 'El título debe tener más de 5 caractéres',
    //   'maxlength': 'El título debe tener menos de 50 caracteres.',
    // },
    'texto': {
      'required': 'El texto es obligatorio.',
      'minlength': 'La descripcion debe tener más de 5 caractéres',
      'maxlength': 'La descripcion debe tener menos de 300 caracteres.',
    },
    // 'precio': {
    //   'required': 'El valor es obligatorio.',
    //   'maxlength': 'El valor debe tener menos de 7 cifras.',
    //   'pattern': 'El valor debe ser un número entero positivo.',
    // }
  }

  constructor(private fs: FotosService, private archServ: ArchivoService, public activeModal: NgbActiveModal, public snackBar: MatSnackBar, private router: Router, public authService: AuthService, public publicacionService: PublicacionService, public fb: FormBuilder) { }

  ngOnInit() {


    this.formulario = this.fb.group({
      // 'categoria': ['', [Validators.required]],
      // 'titulo': [ '', [Validators.required,Validators.minLength(5),Validators.maxLength(50)]],
      'texto': ['', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]],
      // 'precio': ['', [Validators.required,Validators.pattern('^[1-9]+[0-9]*$'), Validators.maxLength(7)]],
      // 'fono': [{value: '', disabled: true}],
      // 'movil': [{value: '', disabled: true}],
      // 'email': [{value: '', disabled: true}],
    });
    this.formulario.valueChanges.subscribe(data => this.detectarCambios(data));
    this.detectarCambios();


    this.publicacionService.crearPub().then(ref => {
      this.publicacionId = ref.id;
      this.fotos$ = this.fs.getFotos(this.publicacionId);
      console.log('Added document with ID: ', ref.id);
    });

  }

  detectarCambios(data?: any) {
    if (!this.formulario) { return; }
    const form = this.formulario;
    for (const field in this.formErrores) {
      this.formErrores[field] = '';
      const control = form.get(field);
      if (control && control.dirty && !control.valid) {
        const messages = this.mensajesValidacion[field];
        for (const key in control.errors) {
          this.formErrores[field] += messages[key] + ' ';
        }
      }
    }
  }

  // get categoria() { return this.formulario.get('categoria') }
  // get titulo() { return this.formulario.get('titulo') }
  get texto() { return this.formulario.get('texto') }
  // get precio() { return this.formulario.get('precio') }
  // get fono() { return this.formulario.get('fono') }
  // get movil() { return this.formulario.get('movil') }
  // get email() { return this.formulario.get('email') }

  publicar(user: User) {
    this.cargando = true;

    // for(var i=0;i<this.categorias.length;i++){
    //   if(this.categorias[i].nombre==this.categoria.value){
    //     this.iconoCat = this.categorias[i].icono;
    //   }
    // }

    var texto_con_espacio = this.texto.value.replace(new RegExp('\n', 'g'), "<br>");

    this.publicacionService.actualizarPublicacion(this.publicacionId,
      {
        descripcion: texto_con_espacio,
        publicado: true,
        fecha: firebase.firestore.FieldValue.serverTimestamp(),
      }
    );
    this.activeModal.close('Publicar y Cerrar');
    this.router.navigate(['/mispublicaciones/' + user.uid]);
    this.snackBar.open('Tu publicación ha sido agregada correctamente.', 'CERRAR', {
      duration: 4000
    });

  }

  cerrarModal(publicacionId: string) {
    this.publicacionService.eliminarPublicacion(publicacionId);
    this.activeModal.close();
  }

  cargaMultiple(evento: FileList) {
    this.loading = true;
    let archivos = evento;
    let archivosIndex = _.range(archivos.length)
    _.each(archivosIndex, (index) => {
      this.listaArchivos = new Archivo(archivos[index]);
      this.listaArchivos.publicacionId = this.publicacionId;
      this.archServ.subir(this.listaArchivos);
    }
    )
    setTimeout(() => {
      this.loading = false;
    }, 3000);

    // this.loading = false;    

  }

}



// WEBPACK FOOTER //
// ./src/app/publicaciones/publicar/publicar.component.ts